import { render, staticRenderFns } from "./RightRanking.vue?vue&type=template&id=12401713&scoped=true"
import script from "./RightRanking.vue?vue&type=script&lang=js"
export * from "./RightRanking.vue?vue&type=script&lang=js"
import style0 from "./RightRanking.vue?vue&type=style&index=0&id=12401713&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12401713",
  null
  
)

export default component.exports